import { render } from "./side_drawer.vue?vue&type=template&id=3204f185"
import script from "./side_drawer.js?vue&type=script&lang=js&external"
export * from "./side_drawer.js?vue&type=script&lang=js&external"

import "./side_drawer.vue?vue&type=style&index=0&id=3204f185&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__